const DESKTOP = window.matchMedia('(min-width: 750px)');

const CARD_FOOTPRINT = 320 + 168 + 24;

class SodShoppable extends HTMLElement {
  connectedCallback() {
    this.stage = this.querySelector('.sod-shop__stage');
    this.zoom = this.querySelector('.sod-shop__zoom');
    this.pins = Array.from(this.querySelectorAll('.sod-shop__pin'));
    this.cards = Array.from(this.querySelectorAll('.sod-shop__card'));
    this.open = null;

    this.pins.forEach((p) => p.addEventListener('click', this.onPin));

    this.cards.forEach((card) => {
      const track = card.querySelector('[data-track]');
      const dots = Array.from(card.querySelectorAll('.sod-shop__dot'));
      if (!track || !dots.length) return;
      track.addEventListener('scroll', () => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach((d, j) => d.classList.toggle('is-active', j === i));
      }, { passive: true });
      dots.forEach((d, j) => d.addEventListener('click', () => {
        track.scrollTo({ left: j * track.clientWidth, behavior: 'smooth' });
      }));
    });
    this.querySelectorAll('[data-close]').forEach((b) => b.addEventListener('click', this.close));
    document.addEventListener('keydown', this.onKey);
    DESKTOP.addEventListener('change', this.close);
  }

  disconnectedCallback() {
    this.pins.forEach((p) => p.removeEventListener('click', this.onPin));
    this.querySelectorAll('[data-close]').forEach((b) => b.removeEventListener('click', this.close));
    document.removeEventListener('keydown', this.onKey);
    DESKTOP.removeEventListener('change', this.close);
    document.documentElement.style.overflow = '';
  }

  onKey = (event) => {
    if (event.key !== 'Escape' || this.open === null) return;
    // Escape inside the quick-add dialog or the cart drawer is theirs, not the card's.
    if (event.target instanceof Element && event.target.closest('dialog')) return;
    this.close();
  };

  onPin = (event) => {
    const index = Number(event.currentTarget.dataset.index);
    if (this.open === index) return this.close();
    this.show(index);
  };

  show(index) {
    const pin = this.pins[index];
    if (!pin) return;

    const card = this.cards[index];

    if (DESKTOP.matches) this.applyZoom(pin);

    this.cards.forEach((c) => {
      c.hidden = c !== card;
      c.classList.remove('is-in');
    });
    this.pins.forEach((p) => p.setAttribute('aria-expanded', String(p === pin)));

    if (card) {
      const track = card.querySelector('[data-track]');
      if (track) track.scrollLeft = 0;
      void card.offsetWidth;
      card.classList.add('is-in');

      card.querySelectorAll('video').forEach((v) => {
        if (!v.getClientRects().length) return;
        if (v.dataset.poster && !v.poster) v.poster = v.dataset.poster;
        v.play().catch(() => {});
      });
    }

    if (!DESKTOP.matches) document.documentElement.style.overflow = 'hidden';

    this.classList.add('is-open');
    this.open = index;
  }

  applyZoom(pin) {
    const stage = this.stage.getBoundingClientRect();
    const dot = pin.getBoundingClientRect();
    const { width } = stage;
    const scale = Number(getComputedStyle(this).getPropertyValue('--sod-shop-zoom')) || 1;
    const fx = (dot.left + dot.width / 2 - stage.left) / width;
    const fy = (dot.top + dot.height / 2 - stage.top) / stage.height;

    const free = Math.max(width - CARD_FOOTPRINT, width * 0.35);
    const targetX = (free * 0.56) / width;
    const targetY = 0.32;

    const fit = (value) => Math.min(0, Math.max(1 - scale, value));

    this.style.setProperty('--sod-shop-scale', String(scale));
    this.style.setProperty('--sod-shop-tx', `${(fit(targetX - fx * scale) * 100).toFixed(3)}%`);
    this.style.setProperty('--sod-shop-ty', `${(fit(targetY - fy * scale) * 100).toFixed(3)}%`);
  }

  close = () => {
    document.documentElement.style.overflow = '';
    this.classList.remove('is-open');
    this.style.removeProperty('--sod-shop-scale');
    this.style.removeProperty('--sod-shop-tx');
    this.style.removeProperty('--sod-shop-ty');
    this.pins.forEach((p) => p.setAttribute('aria-expanded', 'false'));

    this.cards.forEach((c) => {
      c.querySelectorAll('video').forEach((v) => v.pause());
      c.classList.remove('is-in');

      setTimeout(() => { if (!c.classList.contains('is-in')) c.hidden = true; }, 360);
    });

    this.open = null;
  };
}

if (!customElements.get('sod-shoppable')) {
  customElements.define('sod-shoppable', SodShoppable);
}
